import Metadata from '../components/Metadata';
import { metadata, companyInfo } from '../data';

export default function VisitUs() {
  return (
    <div className="bg-wine-950 text-sand-50 min-h-screen font-sans">
      <Metadata title={metadata.visitUs.title} description={metadata.visitUs.description} />

      {/* Hero Header */}
      <section className="relative py-24 border-b border-wine-900/40 bg-wine-950 text-center overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/popup-winebar.jpg"
            alt="La Fable Pop-up"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-wine-950/90 via-wine-950/70 to-wine-950" />
        </div>

        <div className="relative z-10 mx-auto max-w-7xl px-6 space-y-4">
          <span className="font-sans text-xs tracking-[0.3em] uppercase text-sand-300 block font-normal">
            Kompagnistræde 11, Copenhagen K
          </span>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-sand-50 tracking-tighter uppercase">
            Visit Us
          </h1>
          <div className="w-12 h-[1px] bg-wine-700/60 mx-auto my-4" />
          <p className="mx-auto max-w-2xl font-sans text-sm sm:text-base font-normal text-sand-200/80 leading-relaxed">
            Stop by for a glass and get a taste of the atmosphere that will soon find a permanent home downstairs.
          </p>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20 bg-sand-50 text-sand-800">
        <div className="mx-auto max-w-5xl px-6">
          {/* Contact, Location, Socials, Hours */}
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.25fr] gap-12 md:gap-16 items-stretch">
            <div className="space-y-8">
              <div className="space-y-3">
                <span className="font-sans text-xs tracking-[0.2em] uppercase text-sand-800/60 block font-normal">
                  Practical Info
                </span>
                <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-black text-wine-900 tracking-tighter uppercase">
                  Location & Hours
                </h2>
              </div>

              {/* Info Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {/* Location & Contact */}
                <div className="space-y-6">
                  <div>
                    <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-wine-900 mb-2">
                      Location
                    </h4>
                    <p className="font-sans text-sm font-normal text-sand-800/90 leading-relaxed">
                      Kompagnistræde 11, <br />
                      1208 København K
                    </p>
                  </div>

                  <div>
                    <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-wine-900 mb-2">
                      Contact
                    </h4>
                    <p className="font-sans text-sm font-normal text-sand-800/90 leading-relaxed space-y-1">
                      <span className="block">Tel. {companyInfo.phone}</span>
                      <a href={`mailto:${companyInfo.email}`} className="block underline hover:text-wine-900 transition-colors">
                        {companyInfo.email}
                      </a>
                    </p>
                  </div>

                  <div>
                    <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-wine-900 mb-2">
                      Social
                    </h4>
                    <div className="flex flex-col gap-2 font-sans text-sm font-normal text-sand-800/90">
                      <a 
                        href={companyInfo.instagram} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="hover:text-wine-900 transition-colors inline-flex items-center gap-2"
                      >
                        <i className="fa-brands fa-instagram text-wine-900" />
                        @lafablecph
                      </a>
                      <a 
                        href={companyInfo.laFontaineInstagram} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="hover:text-wine-900 transition-colors inline-flex items-center gap-2"
                      >
                        <i className="fa-brands fa-instagram text-wine-900" />
                        @lafontainecph
                      </a>
                      <a 
                        href={companyInfo.facebook} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="hover:text-wine-900 transition-colors inline-flex items-center gap-2"
                      >
                        <i className="fa-brands fa-facebook text-wine-900" />
                        La Fontaine Jazzklub
                      </a>
                    </div>
                  </div>
                </div>

                {/* Opening Hours */}
                <div className="space-y-6">
                  <div>
                    <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-wine-900 mb-2">
                      La Fable pop-up
                    </h4>
                    <p className="font-sans text-sm font-normal text-sand-800/90 leading-relaxed">
                      Wed-Sun <br />
                      From around 15:00 until midnight <br />
                      <span className="text-xs text-sand-500 font-normal italic">weather permitting</span>
                    </p>
                  </div>

                  <div>
                    <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-wine-900 mb-2">
                      La Fontaine
                    </h4>
                    <p className="font-sans text-sm font-normal text-sand-800/90 leading-relaxed space-y-1">
                      <span className="block">Mon-Thu: 20:00-03:00</span>
                      <span className="block">Fri-Sat: 20:00-05:00</span>
                      <span className="block">Sun: 20:00-03:00</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Small Map Teaser / Card */}
            <div className="relative rounded-none overflow-hidden shadow-lg h-64 md:h-auto min-h-[320px] bg-black border border-white/10 flex flex-col justify-end p-6 w-full">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/image_1.png"
                alt="La Fable Pop-up"
                className="absolute inset-0 w-full h-full object-cover opacity-90 block"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="relative z-10 text-sand-50">
                <p className="font-serif text-xl mb-1">Kompagnistræde 11</p>
                <p className="font-sans text-xs text-sand-300 uppercase tracking-widest">Copenhagen K</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
